<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary pos-relative {{ sectionclass }}"
	style="min-height: 23em"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		*ngIf="hasData"
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative custom-primary"
	>
		<div class="o-stack__cell">
			<h5>
				{{ sectiontitle }}
				<span class="downloadIconHeader">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadDataInCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					>
						<img class="downloadIcon" src="{{ downloadIcon }}" />
					</a>
				</span>
			</h5>
		</div>
	</div>
	<div class="analytics-portlet-content" [ngClass]="{ 'no-venue-type-data': !hasData }">
		<div style="width: 100%; height: 100%" class="venue-type-graph">
			<div id="chart" #graphArea></div>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div
				style="width: 100%; position: absolute; top: 15px"
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative custom-primary"
			>
				<div class="o-stack__cell">
					<h5>{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>

	<div
		class="analytics-portlet-content child-venue-type-portlet-content"
		[ngClass]="{ 'no-venue-type-data': !hasData }"
	>
		<div style="width: 100%; height: 100%" class="child-venue-type-graph">
			<div id="childChart" #childGraphArea></div>
		</div>
		<div class="child-venue-type-no-data" *ngIf="!hasChildVenueData">
			Select a venue type above to view breakdown of venue type impressions
		</div>
	</div>
</div>
